import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Identifiable, OrganizationalUnit } from "@planzone/dto";
import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { OrganizationalUnitsHierarchy } from "@common/organizationalUnitsHierarchy";
import { Props } from "./types";
import styles from "./styles.scss";

function OrganizationalUnitSelection({
  sourceOrganizationalUnit,
  destination,
  placeholder,
  select,
}: Props) {
  const { t } = useTranslation();
  const isSelected = ({ uuid }: Identifiable<OrganizationalUnit>) =>
    destination !== null && destination !== "root" && destination.uuid === uuid;

  return (
    <SelectList
      rootClassName={styles.organizationalUnitSelection}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select: s }) => ({
        input: (
          <div
            className={classNames(styles.input, { [styles.opened]: isOpen })}
          >
            {destination === null ? (
              <p className={styles.placeholder}>{placeholder}</p>
            ) : (
              <p>
                {destination === "root"
                  ? t("moveOrganizationalUnit.root")
                  : destination.name}
              </p>
            )}
            <ToggleArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <div className={styles.list}>
            {/* The back leaves out the moved unit with its subtree: a unit can't move under itself. */}
            <OrganizationalUnitsHierarchy
              excludedUuid={sourceOrganizationalUnit.uuid}
              isSelected={isSelected}
              select={(organizationalUnit) =>
                s(
                  select(
                    isSelected(organizationalUnit) ? null : organizationalUnit,
                  ),
                )
              }
            >
              <div
                className={classNames(styles.name, {
                  [styles.selected]: destination === "root",
                })}
                onClick={() =>
                  s(select(destination === "root" ? null : "root"))
                }
              >
                <p>{t("moveOrganizationalUnit.root")}</p>
              </div>
            </OrganizationalUnitsHierarchy>
          </div>
        ),
      })}
    </SelectList>
  );
}

export { OrganizationalUnitSelection };
